angular.module('app').directive("uploadFile", [
    '$rootScope', '$timeout','uploadImageParams', 'logger', 'Utils',
    function ($rootScope, $timeout, uploadImageParams, logger, Utils) {
        return {
            restrict: "A",
            scope: {
                uploadFile: "=",
                deleteProperty: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var self = this,
                        reader = new FileReader(),
                        showValue = attributes.showValue || false;

                   /* $timeout(
                        function () {
                            scope.$apply(function () {
                                scope.uploadFile = "";
                            });
                        }
                    );*/
                    reader.onload = function (loadEvent) {
                        $timeout(
                            function () {
                                scope.$apply(function () {
                                        scope.uploadFile = Utils.fixImageBase64URL(changeEvent.target.files[0], loadEvent.target.result);
                                        scope.deleteProperty = undefined;
                                        $rootScope.$broadcast("image:uploaded");
                                        if(!showValue) {
                                            self.value = "";
                                        }

                                });
                            }
                        );

                        /*scope.$digest(scope.uploadFile = loadEvent.target.result)*/
                    };
                    reader.onerror = function () {
                        scope.$apply(function () {
                            scope.uploadFile = ""
                        });
                    };

                    if (attributes.original != undefined) {
                        scope.$parent[attributes.original] = changeEvent.target.files[0];
                    }
                    Utils.checkFileAndMakeWarning(changeEvent.target.files[0], logger);
                    if (changeEvent.target.files[0].size > uploadImageParams.imageSiza) {
                        var fileSizeConvert = changeEvent.target.files[0].size / 1048576;
                        logger.logError("Max file size is 4MB. Your file is " + ' ' + fileSizeConvert.toFixed(2) + 'MB');
                    } else {
                        reader.readAsDataURL(changeEvent.target.files[0]);
                    }
                });
            }
        }
    }]);
